import * as React from "react";
const OilAndGasSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m30.125 8.707-2.418-2.415a1 1 0 1 0-1.415 1.415l2.415 2.418a1 1 0 0 1 .293.704V21a1 1 0 0 1-2 0v-5a3 3 0 0 0-3-3h-2V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v19H4a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2h-2V15h2a1 1 0 0 1 1 1v5a3 3 0 0 0 6 0V10.829a2.983 2.983 0 0 0-.875-2.122ZM8 26V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v19H8Zm10-12a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1Z"
    />
  </svg>
);
export default OilAndGasSVG;
